import { dayTours } from "../data/tours";
import "./DayTours.css";
import { Link } from "react-router-dom";

export default function DayTours() {
  return (
    <section className="day-tours">
      <h2>🌴 Zanzibar Day Tours</h2>
      <div className="tour-grid">
        {dayTours.map((tour) => (
          <div key={tour.id} className="tour-card">
            <img src={tour.image} alt={tour.title} className="tour-image" />
            <h3>{tour.title}</h3>
            <p className="location">📍 {tour.location}</p>
            <p>{tour.description}</p>
            <Link to={tour.cta.href} className="btn-readmore">
              {tour.cta.label}
            </Link>
          </div>
        ))}
      </div>
    </section>
  );
}
